import * as React from 'react';
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { Panel } from "./index";
import IconComponent from "../IconComponent";
import PartnerWall from "../PartnerWall";

/**
 * PanelMatrixPartner
 * @constructor
 */
export function PanelMatrixPartner() {
  /**
   * context
   */
  const {
    I18N,
    getRoutes
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  return (
    <Panel
      header={<>
        <IconComponent iconName={ ROUTE_CONFIG.PARTNER_OVERVIEW.icon } />
        {I18N.t('Meine Partner')}
      </>}
      // @ts-ignore
      style={{ '--dia-panel-padding-content': 0 }}
    >
      <PartnerWall />
    </Panel>
  );
}
